import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal, message, Statistic } from 'antd';
import { isIncluded, formatDate, eventListener, ReferralIcon } from '../utils';
import { SubmitIcon } from '../utils';
import ReactToPrint from 'react-to-print';
import { apis } from '../api/index.js';
import PrintReport from './PrintReport.js';
import { dangerKeyword } from './dangerKeyword';
import qs from 'query-string';
const { confirm } = Modal;
const { Countdown } = Statistic;
const productionId = '101';
class ReportButtons extends React.Component {
  static propTypes = {
    reportInfo: PropTypes.object,
    role: PropTypes.array,
    saveReport: PropTypes.func,
    history: PropTypes.object,
    tipAlertVisible: PropTypes.func,
    refuseVisible: PropTypes.func,
    historyModalVisible: PropTypes.func,
    changeMenuTaskData: PropTypes.func,
    getWriteReport: PropTypes.func,
    getVerifyReport: PropTypes.func,
    update: PropTypes.func,
    getReportInfo: PropTypes.func,
    lastTime: PropTypes.string,
    endTime: PropTypes.number,
    dangerChecked: PropTypes.bool,
    oldFinding: PropTypes.string,
    oldSug: PropTypes.string,
    // nboxReviewResult: PropTypes.string,
    // nboxReviewDetails: PropTypes.string,
    // evaluateTip: PropTypes.func,
    // evaluateVisible: PropTypes.bool,
    deadline: PropTypes.number,
    minTime: PropTypes.number,
    reportType: PropTypes.string,
    nboxReviewResultCode: PropTypes.string,
    tsReview: PropTypes.func,
  };
  constructor(props) {
    super(props);
    this.state = {
      submitBtnDisabled: true,
      visible: false,
      radiovalue: true,
    };
  }

  componentDidMount = () => {
    const update = qs.parse(window.location.search).update;
    if (update === '1') this.setState({ submitBtnDisabled: false });
  };

  componentDidUpdate = prevProps => {
    const { reportInfo } = this.props;
    if (reportInfo !== prevProps.reportInfo) {
      const { patientSource } = reportInfo;
      if (patientSource === 2) this.setState({ submitBtnDisabled: false });
    }
  };

  handlePrinter = id => {
    const { reportInfo } = this.props;
    const diagId = reportInfo.diagId;
    apis.permitPrintReport(diagId).then(res => {
      if (res.code === '0') {
        const stateArray = [201, 20];
        if (stateArray.indexOf(reportInfo.state) >= 0) {
          confirm({
            title: '提示',
            content: '夜间急诊报告非正式报告，继续打印吗？',
            okText: '继续打印',
            okType: 'danger',
            cancelText: '取消',
            onOk() {
              document.getElementById(id).click();
            },
          });
        } else document.getElementById(id).click();
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };
  handleSubmit = () => {
    const [pageId, moduleId, elementId] = ['10019', 'mk0004', 'ns-001'];
    eventListener({ productionId, pageId, moduleId, elementId });

    const { reportInfo, dangerChecked } = this.props;
    const { nboxReviewResultCode } = this.props;
    // const { evaluateVisible,nboxReviewResult } = this.props;
    const {
      radiographyDescription,
      diagnosisDescription,
      aiReportUrl,
    } = reportInfo;
    if (!radiographyDescription || !diagnosisDescription) {
      message.warning('请填写影像所见和诊断建议后再提交');
    } else if (!nboxReviewResultCode && aiReportUrl) {
      message.warning('请完成AI结果评价后再提交');
    } else {
      if (dangerChecked) {
        this.props.tipAlertVisible(true, 'submit');
      } else {
        let flag = false;
        dangerKeyword.forEach(item => {
          if (radiographyDescription.includes(item)) flag = true;
          if (diagnosisDescription.includes(item)) flag = true;
        });
        this.props.tipAlertVisible(true, flag ? 'dangerSubmit' : 'submit');
      }
    }
  };
  handleSubmitReview = (needReview2, type) => {
    const { reportInfo, dangerChecked, oldFinding, oldSug } = this.props;
    const { reportType } = this.props;
    const { nboxReviewResultCode } = this.props;
    const { diagnosisGrade, state, aiFinding, aiImpression } = reportInfo;
    const { radiographyDescription, diagnosisDescription } = reportInfo;
    const { aiReportUrl } = reportInfo;
    //reportType === '1'提交的是医生诊断报告取医生的值
    //reportType === '2'提交的是AI辅助诊断报告取AI的值
    if (
      (reportType === '1' && !radiographyDescription) ||
      (reportType === '2' && !aiFinding)
    ) {
      message.warning('请输入影像所见');
    } else if (
      (reportType === '1' && !diagnosisDescription) ||
      (reportType === '2' && !aiImpression)
    ) {
      message.warning('请输入诊断建议');
    } else if (typeof diagnosisGrade !== 'number' && state === 21) {
      message.warning('请对报告进行评价');
    } else if (!nboxReviewResultCode && type === 'review' && aiReportUrl) {
      message.warning('请对AI结果进行评价');
    } else if (
      dangerChecked ||
      (oldFinding === radiographyDescription && oldSug === diagnosisDescription)
    ) {
      this.props.tipAlertVisible(true, needReview2 ? 'review2' : 'review');
    } else {
      let flag = false;
      dangerKeyword.forEach(item => {
        if (
          radiographyDescription.includes(item) ||
          diagnosisDescription.includes(item)
        )
          flag = true;
      });
      let name = '';
      if (flag && needReview2) name = 'dangerReview2';
      else if (flag) name = 'dangerReview';
      else if (needReview2) name = 'review2';
      else name = 'review';
      this.props.tipAlertVisible(true, name);
    }
  };

  //撤销报告
  undoReport = () => {
    this.setState({ isLoading: true });
    const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
    this.props.changeMenuTaskData(time);
    const { reportInfo } = this.props;
    apis.undoReport(reportInfo.diagId).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') this.props.getWriteReport(reportInfo.diagId);
      else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  //撤销审核
  undoVerify = () => {
    this.setState({ isLoading: true });
    const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
    this.props.changeMenuTaskData(time);
    const { reportInfo } = this.props;
    apis.undoVerify(reportInfo.diagId).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') this.props.getVerifyReport(reportInfo.diagId);
      else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  //预览报告
  handlePreview = () => {
    const { reportInfo } = this.props;
    const xpwidth = window.screen.width - 10;
    const xpheight = window.screen.height - 105;
    const url = `/report/preview/${reportInfo.applicationId}`;
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${xpwidth},height=${xpheight}`;
    window.open(url, 'reportpreview', str);
  };

  //报告纠错
  undoPrintReport = () => {
    this.setState({ isLoading: true });
    const time = formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss');
    this.props.changeMenuTaskData(time);
    const { reportInfo } = this.props;
    apis.undoPrintReport(reportInfo.diagId).then(res => {
      this.setState({ isLoading: false });
      if (res.code === '0') this.props.getReportInfo(reportInfo.applicationId);
      else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  printReport = () => {
    const { reportInfo } = this.props;
    apis.printReport(reportInfo.diagId).then(res => {
      if (res.code === '0') this.props.update(res.data);
      else if (res.code === '1009') this.props.history.push('/login');
    });
  };

  setToVerify2 = () => {
    const { reportInfo } = this.props;
    apis.toVerify2(reportInfo.diagId).then(res => {
      if (res.code === '0') {
        message.success('转诊成功');
        this.props.history.go(-1);
      }
    });
  };
  countdownFinished = () => {
    this.setState({ submitBtnDisabled: false });
  };
  getButtons = () => {
    let { submitBtnDisabled } = this.state;

    const isSmall = document.body.clientWidth < 1200;
    const { reportInfo, role, deadline, minTime, lastTime } = this.props;
    const { endTime } = this.props;
    const userId = window.store.getState().api.user.info.id;
    const buttons = [];
    const state = reportInfo.state;
    if (!state) return buttons;
    //deadline 至少书写结束时间
    //endTime 最多书写结束时间
    //lastTime 最多书写时间（时分秒）
    submitBtnDisabled =
      (endTime && endTime <= deadline) || minTime === 0
        ? false
        : submitBtnDisabled;
    //提交报告
    const submitReport = (
      <div className="report-submit-div">
        <Button
          className="c-319FF1"
          size={isSmall ? 'small' : 'default'}
          onClick={this.handleSubmit}
          disabled={submitBtnDisabled}
        >
          <SubmitIcon />
          提交报告
          <span className="last-time">（剩余：{lastTime}）</span>
        </Button>
        {submitBtnDisabled && (
          <Countdown
            value={deadline}
            onFinish={this.countdownFinished}
            format="ss"
            prefix="请仔细书写报告，"
            suffix="s后才能提交报告"
          />
        )}
      </div>
    );

    //提交审核
    const submitVerify = (
      <div className="report-submit-div">
        <Button
          className="c-319FF1"
          size={isSmall ? 'small' : 'default'}
          onClick={() => {
            const [pageId, moduleId, elementId] = ['10020', 'mk0004', 'ns-001'];
            eventListener({ productionId, pageId, moduleId, elementId });

            this.handleSubmitReview(false, 'review');
          }}
          disabled={submitBtnDisabled}
        >
          <SubmitIcon />
          审核完成
          <span>（剩余：{this.props.lastTime}）</span>
        </Button>
        {submitBtnDisabled && (
          <Countdown
            value={deadline}
            onFinish={this.countdownFinished}
            format="ss"
            prefix="请仔细书写报告，"
            suffix="s后才能提交报告"
          />
        )}
      </div>
    );

    //疑难转诊
    const hardReferral = (
      <Button
        className="c-e89056"
        size={isSmall ? 'small' : 'default'}
        onClick={() => this.handleSubmitReview(true)}
      >
        <ReferralIcon style={{ marginTop: '2px', verticalAlign: 'top' }} />
        疑难转诊
      </Button>
    );

    //退回重写
    const refuseReView = (
      <Button
        className="c-DD6666"
        icon="rollback"
        size={isSmall ? 'small' : 'default'}
        onClick={() => {
          const [pageId, moduleId, elementId] = ['10020', 'mk0004', 'ns-004'];
          eventListener({ productionId, pageId, moduleId, elementId });
          this.props.tipAlertVisible(true, 'refuseReView');
        }}
      >
        退回重写
      </Button>
    );

    //暂存报告
    const saveReport = (
      <Button
        className="c-4382CF"
        icon="save"
        size={isSmall ? 'small' : 'default'}
        onClick={() => {
          const [pageId, moduleId, elementId] = ['10019', 'mk0004', 'ns-002'];
          eventListener({ productionId, pageId, moduleId, elementId });

          this.props.saveReport(0);
        }}
      >
        暂存报告
      </Button>
    );

    //放弃填写
    const giveupReport = (
      <Button
        className="c-95A9C1"
        icon="close"
        size={isSmall ? 'small' : 'default'}
        onClick={() => {
          const [pageId, moduleId, elementId] = ['10019', 'mk0004', 'ns-003'];
          eventListener({ productionId, pageId, moduleId, elementId });

          this.props.tipAlertVisible(true, 'quitReport');
        }}
      >
        放弃填写
      </Button>
    );

    //拒绝报告
    const refuseReport = (
      <Button
        className="c-DD6666"
        icon="stop"
        size={isSmall ? 'small' : 'default'}
        onClick={() => {
          const [pageId, moduleId, elementId] = ['10019', 'mk0004', 'ns-004'];
          eventListener({ productionId, pageId, moduleId, elementId });

          this.props.refuseVisible(true);
        }}
      >
        拒绝报告
      </Button>
    );

    //操作记录
    const history = (
      <Button
        className="c-559ACD"
        icon="file-protect"
        size={isSmall ? 'small' : 'default'}
        onClick={() => {
          const { reportInfo } = this.props;
          const { state } = reportInfo;
          if ([21, 26].includes(state)) {
            const [pageId, moduleId, elementId] = ['10020', 'mk0004', 'ns-002'];
            eventListener({ productionId, pageId, moduleId, elementId });
          } else {
            const [pageId, moduleId, elementId] = ['10021', 'mk0002', 'ns-001'];
            eventListener({ productionId, pageId, moduleId, elementId });
          }
          this.props.historyModalVisible(true);
        }}
      >
        操作记录
      </Button>
    );

    //修改报告-填写
    const undoReport = (
      <Button
        className="c-319FF1"
        size={isSmall ? 'small' : 'default'}
        icon="edit"
        onClick={this.undoReport}
      >
        &nbsp; 修改报告
      </Button>
    );

    //修改报告-审核
    const undoVerify = (
      <Button
        className="c-319FF1"
        size={isSmall ? 'small' : 'default'}
        icon="edit"
        onClick={this.undoVerify}
      >
        修改报告
      </Button>
    );

    //预览报告
    const preview = (
      <Button
        className="c-319FF1"
        size={isSmall ? 'small' : 'default'}
        icon="eye"
        onClick={() => {
          const [pageId, moduleId, elementId] = ['10021', 'mk0002', 'ns-002'];
          eventListener({ productionId, pageId, moduleId, elementId });
          this.handlePreview();
        }}
      >
        预览报告
      </Button>
    );

    //打印报告
    const printImageReport = (
      <div className="printer-div">
        <Button
          className="c-53D7DB printer-cover"
          icon="printer"
          size={isSmall ? 'small' : 'default'}
          onClick={() => {
            const [pageId, moduleId, elementId] = ['10021', 'mk0002', 'ns-003'];
            eventListener({ productionId, pageId, moduleId, elementId });
            this.handlePrinter('printer1');
          }}
        >
          打印图文报告
        </Button>
        <ReactToPrint
          trigger={() => (
            <Button
              className="c-53D7DB"
              size={isSmall ? 'small' : 'default'}
              icon="printer"
              id="printer1"
            >
              打印图文报告
            </Button>
          )}
          content={() => this.componentRef1}
          onAfterPrint={() => this.printReport()}
        />
      </div>
    );

    //打印报告
    const printTxtReport = (
      <div className="printer-div">
        <Button
          className="c-53D7DB printer-cover"
          icon="printer"
          size={isSmall ? 'small' : 'default'}
          onClick={() => {
            const [pageId, moduleId, elementId] = ['10021', 'mk0002', 'ns-004'];
            eventListener({ productionId, pageId, moduleId, elementId });
            this.handlePrinter('printer2');
          }}
        >
          打印文字报告
        </Button>
        <ReactToPrint
          trigger={() => (
            <Button
              className="c-53D7DB"
              size={isSmall ? 'small' : 'default'}
              icon="printer"
              id="printer2"
            >
              打印文字报告
            </Button>
          )}
          content={() => this.componentRef2}
          onAfterPrint={() => this.printReport()}
        />
      </div>
    );

    //报告纠错
    const reportError = (
      <Button
        className="c-559ACD"
        icon="file-protect"
        size={isSmall ? 'small' : 'default'}
        onClick={() => {
          const [pageId, moduleId, elementId] = ['10021', 'mk0002', 'ns-005'];
          eventListener({ productionId, pageId, moduleId, elementId });
          this.undoPrintReport();
        }}
      >
        报告纠错
      </Button>
    );
    //放弃审核
    const giveupVerify = (
      <Button
        className="c-95A9C1"
        icon="close"
        size={isSmall ? 'small' : 'default'}
        onClick={() => {
          const [pageId, moduleId, elementId] = ['10020', 'mk0004', 'ns-003'];
          eventListener({ productionId, pageId, moduleId, elementId });
          this.props.tipAlertVisible(true, 'quitVerify');
        }}
      >
        放弃审核
      </Button>
    );
    //提交修改
    const submitUpdate = (
      <Button
        className="c-319FF1"
        size={isSmall ? 'small' : 'default'}
        onClick={() => this.handleSubmitReview(false)}
      >
        <SubmitIcon />
        提交修改
      </Button>
    );

    //暂存审核
    const tsReviewBtn = (
      <Button
        className="c-319FF1"
        size={isSmall ? 'small' : 'default'}
        onClick={() => this.props.tsReview(0)}
        icon="save"
      >
        暂存审核
      </Button>
    );
    switch (state) {
      case 11: {
        const flag = isIncluded(['M'], role);
        if (flag) {
          //报告中-填写报告
          buttons.push(saveReport, giveupReport, refuseReport, submitReport);
        }
        break;
      }
      case 25:
      case 20: {
        // 修改报告-填写
        if (reportInfo.reportUser === userId && state === 20) {
          buttons.push(undoReport);
        } else if (reportInfo.verifyUser === userId && state === 25) {
          buttons.push(undoVerify);
        }
        const flag1 = isIncluded(['M', 'T'], role);
        if (flag1) buttons.push(history);

        if (reportInfo.emergencyFlag === 2 && flag1)
          buttons.push(preview, printImageReport, printTxtReport);
        break;
      }
      case 251:
      case 201: {
        buttons.push(history);
        const flag1 = isIncluded(['M', 'Q', 'T', 'T2'], role);
        if (reportInfo.emergencyFlag === 2 && flag1) {
          buttons.push(preview, printImageReport, printTxtReport);
        }
        break;
      }
      case 22:
      case 42:
      case 30:
      case 46: {
        // 修改报告-审核
        if (
          reportInfo.verifyUser === userId &&
          reportInfo.state === 22 &&
          !reportInfo.verify2User
        ) {
          buttons.push(undoVerify);
        } else if (
          reportInfo.verify2User === userId &&
          reportInfo.state === 22
        ) {
          buttons.push(undoVerify);
        }
        buttons.push(history, preview, printImageReport, printTxtReport);
        //报告纠错
        const flag1 = isIncluded(['M', 'T', 'T2'], role);
        if (flag1 && (reportInfo.state === 30 || reportInfo.state === 46)) {
          buttons.push(reportError);
        }
        break;
      }
      case 21: {
        const flag = isIncluded(['T'], role);
        if (flag) {
          // 审核报告
          buttons.push(
            history,
            giveupVerify,
            tsReviewBtn,
            refuseReView,
            hardReferral,
            submitVerify
          );
        }
        break;
      }
      case 26: {
        const flag = isIncluded(['T2'], role) || true;
        if (flag) {
          // 审核报告
          buttons.push(history, giveupVerify, submitVerify);
        }
        break;
      }
      case 40:
        // 纠错中
        buttons.push(submitUpdate, history);
        break;
      default:
        break;
    }
    return buttons;
  };
  commentVisible = state => {
    this.setState({ visible: state });
  };
  render() {
    const { reportInfo } = this.props;
    const buttons = this.getButtons();

    return (
      <>
        {buttons.length > 0 && (
          <div className="report-sub-btns">
            {buttons.map((item, index) => (
              <span key={index}>{item}</span>
            ))}
          </div>
        )}

        {/* 图文报告 */}
        <div style={{ display: 'none' }}>
          <div ref={el => (this.componentRef1 = el)}>
            <PrintReport report={reportInfo} reportType="image" />
          </div>
        </div>
        {/* 文字报告 */}
        <div style={{ display: 'none' }}>
          <div ref={el => (this.componentRef2 = el)}>
            <PrintReport report={reportInfo} reportType="text" />
          </div>
        </div>
      </>
    );
  }
}

export default ReportButtons;
